<template>
    <WelcomeBonus
        :isLoading="isLoading"
        :error="error"
        @chooseBonus="onChooseBonus"
    />
</template>

<script>
    import { mapActions } from 'vuex';
    import { routeNames } from '@app/router';
    import BonusService from '@core/services/bonus/BonusService';
    import { errorGuard } from '@app/utils';
    import WelcomeBonus from '@countryModules/bonus/components/WelcomeBonus';

    export default {
        name: 'WelcomeBonusModal',
        data() {
            return {
                isLoading: false,
                isSubmitSuccessful: false,
                error: '',
            };
        },
        methods: {
            ...mapActions('data/authentication', [
                'setUserData',
            ]),
            ...mapActions('ui/modal', [
                'closeAllModals',
            ]),
            async onChooseBonus(key) {
                this.error = '';
                this.isLoading = true;
                await errorGuard({
                    action: async () => {
                        await BonusService.getInstance().setBonus(key);
                        this.setUserData({
                            key: 'welcomeBonus',
                            value: false
                        });
                        this.closeAllModals();
                        this.isSubmitSuccessful = true;
                    },
                    onError: () => {
                        this.error = 'Something went wrong. Please try again';
                    },
                    showGlobalError: false,
                });
                this.isLoading = false;
            }
        },
        destroyed() {
            if (!this.isSubmitSuccessful) {
                this.$router.push({
                    name: routeNames.profile
                });
            }
        },
        components: {
            WelcomeBonus,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modals/modals/welcomeBonus/WelcomeBonusModal.vue